import * as Yup from 'yup';

// Legacy only hard-blocks Save on a missing Plate Number/State (a manual check + warning
// toast). An invalid VIN is flagged with a red border but never actually blocks saving, so
// VIN intentionally has no format validation here.
const addVehicleSchema = Yup.object({
  PlateNumber: Yup.string().nullable().required('Plate number is required'),
  PlateState: Yup.string().nullable().required('Plate state is required'),
});

export default addVehicleSchema;
